import { Card, Form, Radio, Space } from "antd";
import { RETURN_CHANNEL } from "constants/ordersReturn";
import { useTranslation } from "react-i18next";

export default function ReturnChannel() {
   const { t } = useTranslation();
   return (
      <Card title={t('ordersReturn.returnType')}>
         <Form.Item
            name="returnType"
            rules={[
               {
                  required: true,
                  message: t('orders.paymentGroupMethod.validateMsg.required'),
               },
            ]}
            initialValue={RETURN_CHANNEL['ONLINE'].value}
         >
            <Radio.Group>
               <Space direction="vertical" size={15}>
                  {Object.values(RETURN_CHANNEL)?.map((item) => (
                     <Radio key={item.value} value={item.value}>
                        {item?.label}
                     </Radio>
                  ))}
               </Space>
            </Radio.Group>
         </Form.Item>
      </Card>
   )
}